import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import SnSearchBtn from "@shared/components/SnSearchBtn";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_MTL_MPR_REG_001_POP_001 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
      grid1: React.createRef<SnGridRef>(),
    });

    const getGridCurrent = (key: string): SnGridRef => {
      const grid = gridRefs.current[key]?.current;
      if (!grid) {
        throw new Error(`Grid '${key}' is not mounted yet`);
      }
      return grid;
    };

    const searchRef = useRef<any>(null);

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any>({
      grid1: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
    });

    useImperativeHandle(ref, () => ({
      getOkayData: () => {
        return {
          rtnData: [getGridCurrent("grid1").getCheckedRows()],
        };
      },
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_MTL_MPR_REG_001_POP_001",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData);
          setFormData(mergedData);
          setColums({
            grid1: rtn.grid.grid1,
          });
        } catch (error) {}
      };
      fetchform();
    }, []);

    const onSearch = async () => {
      try {
        const param = {
          id: "sn_mtl_mpr_reg_001_pop_001_01",
          params: searchRef.current.getFormdata(),
        };
        getGridCurrent("grid1").resetUpdate();

        const data: any = await fnGetDataSet(param);
        setDataSources({
          grid1: data[0] || [],
        });
      } catch (error: any) {}
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
        },
      }),
      [columns, dataSources]
    );

    return (
      <div>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{
              width: 80,
              marginTop: 1.5,
            }}
            spinner={true}
          />
        </div>
        <div>
          <div style={{ height: "50vh", marginTop: "10px" }}>
            <SnGrid
              ref={gridRefs.current["grid1"]}
              columnConfig={grids.grid1.columns}
              rowData={grids.grid1.dataSource}
              etcProps={{
                rowSelection: "multiple",
                isEditable: false,
                ischeckboxSelection: true,
              }}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default SN_MTL_MPR_REG_001_POP_001;
